import React, { useState } from "react";
import {
  Create,
  SimpleForm,
  ReferenceInput,
  TextInput,
  SelectInput,
  BooleanInput,
  required,
  useRedirect,
} from "react-admin";
import DataProvider from "../../DataProvider.js";
import EditConfirmToolbar from "../../components/EditConfirmToolbar";
import { parse } from "query-string";
import validateZone from "../../validators/ZoneIdValidator";
import UploadZoneMapButton from "../../components/UploadZoneMapButton";
import { filteredAlerts } from "../../defaults/ZoneAlerts";
const ZoneCreate = (props) => {
  const [data, setData] = useState();
  const [isValid, setIsValid] = useState(true);

  const { organization_id } = parse(props.location.search);
  const redirect = organization_id
    ? `/Organizations/${organization_id}/show/`
    : "show";

  const redirectTo = useRedirect();

  const uploadData = async (data) => {
    const zone = await DataProvider.create("zones", { data: { ...data } });
    setData(zone);
  };

  if (isValid && data && data.data)
    redirectTo(
      `/zones/${data.data.id}/show?organization_id=${organization_id}`,
      data.data
    );

  return (
    <Create {...props}>
      <SimpleForm
        toolbar={
          <EditConfirmToolbar
            handlesave={uploadData}
            creating={true}
            history={props.history}
          />
        }
        redirect={redirect}
        validate={validateZone}
      >
        <ReferenceInput
          perPage={1000000000000}
          fullWidth
          label="Organization"
          source="OrganizationId"
          reference="organizations"
          validate={[required()]}
        >
          <SelectInput source="id" initialValue={organization_id} />
        </ReferenceInput>
        <TextInput
          fullWidth
          label="Zone Name"
          source="name"
          validate={[required()]}
        />
        <TextInput
          fullWidth
          label="Zone ID"
          source="customID"
          validate={[required()]}
        />
        <TextInput fullWidth label="Panel ID" source="panel_id" />
        <SelectInput
          fullWidth
          label="Message Type"
          source="message_prefix"
          validate={[required()]}
          choices={filteredAlerts()}
        />
        <TextInput fullWidth label="Message" source="message" />
        <BooleanInput label="Disable MutuaLink" source="mutualink_disabled" />
        <TextInput fullWidth label="Address Line 1" source="address_line_1" />
        <TextInput fullWidth label="Address Line 2" source="address_line_2" />
        <TextInput fullWidth label="City" source="address_city" />
        <SelectInput
          fullWidth
          label="State"
          source="address_state"
          choices={[
            { id: "AK", name: "AK" },
            { id: "AL", name: "AL" },
            { id: "AR", name: "AR" },
            { id: "AZ", name: "AZ" },
            { id: "CA", name: "CA" },
            { id: "CO", name: "CO" },
            { id: "CT", name: "CT" },
            { id: "DC", name: "DC" },
            { id: "DE", name: "DE" },
            { id: "FL", name: "FL" },
            { id: "GA", name: "GA" },
            { id: "HI", name: "HI" },
            { id: "IA", name: "IA" },
            { id: "ID", name: "ID" },
            { id: "IL", name: "IL" },
            { id: "IN", name: "IN" },
            { id: "KS", name: "KS" },
            { id: "KY", name: "KY" },
            { id: "LA", name: "LA" },
            { id: "MA", name: "MA" },
            { id: "MD", name: "MD" },
            { id: "ME", name: "ME" },
            { id: "MI", name: "MI" },
            { id: "MN", name: "MN" },
            { id: "MO", name: "MO" },
            { id: "MS", name: "MS" },
            { id: "MT", name: "MT" },
            { id: "NC", name: "NC" },
            { id: "ND", name: "ND" },
            { id: "NE", name: "NE" },
            { id: "NH", name: "NH" },
            { id: "NJ", name: "NJ" },
            { id: "NM", name: "NM" },
            { id: "NV", name: "NV" },
            { id: "NY", name: "NY" },
            { id: "OH", name: "OH" },
            { id: "OK", name: "OK" },
            { id: "OR", name: "OR" },
            { id: "PA", name: "PA" },
            { id: "RI", name: "RI" },
            { id: "SC", name: "SC" },
            { id: "SD", name: "SD" },
            { id: "TN", name: "TN" },
            { id: "TX", name: "TX" },
            { id: "UT", name: "UT" },
            { id: "VA", name: "VA" },
            { id: "VT", name: "VT" },
            { id: "WA", name: "WA" },
            { id: "WI", name: "WI" },
            { id: "WV", name: "WV" },
            { id: "WY", name: "WY" },
          ]}
        />
        <TextInput fullWidth label="Zip" source="address_zip" />
        <TextInput fullWidth label="Notes" source="notes" />
        <TextInput fullWidth label="Serial #" source="serialNo" />
        <UploadZoneMapButton data={data} setIsValid={setIsValid} />
      </SimpleForm>
    </Create>
  );
};

export default ZoneCreate;
